import filters from './filters'

export default {
  loader: {
    default: {
      NEW: {
        message: resolver => `Creating new ${resolver}, please wait...`,
        state: 'happy'
      },
      UPDATE: {
        message: resolver => `Updating ${resolver}, please wait...`,
        state: 'happy'
      },
      DELETE: {
        message: resolver => `Deleting ${resolver}, please wait...`,
        state: 'sad'
      }
    },

    login: {
      GET_CODE: {
        message: 'Enviando código, por favor esperar',
        state: 'happy'
      },
      LOGIN: {
        message: 'Login in server, please wait...',
        state: 'happy'
      }
    }
  },

  message: {
    default: {
      CREATED: {
        title: resolver => `${filters.capitalize(resolver)} Created`,
        message (value, resolver) {
          return `El ${resolver} "${value}" ha sido creado`
        },
        type: 'ok'
      },
      UPDATED: {
        title: resolver => `${filters.capitalize(resolver)} Updated`,
        message (value, resolver) {
          return `El ${resolver} "${value}" ha sido actualizado`
        },
        type: 'ok'
      },
      DELETED: {
        title: resolver => `${filters.capitalize(resolver)}Deleted`,
        message (value, resolver) {
          return `El ${resolver} "${value}" ha sido eliminado`
        },
        type: 'ok'
      }
    },

    user: {
      CREATED: {
        title: 'User Created',
        message (dni) {
          return `El usuario con documento "${dni}" ha sido creado`
        },
        type: 'ok'
      },
      UPDATED: {
        title: 'User Updated',
        message (dni) {
          return `TEl usuario con documento "${dni}" ha sido actualizado`
        },
        type: 'ok'
      },
      DELETED: {
        title: 'User Deleted',
        message (dni) {
          return `El usuario con documento "${dni}" ha sido eliminado`
        },
        type: 'ok'
      }
    },

    color: {
      CREATED: {
        title: 'Color Created',
        message (color) {
          return `The color "${filters.capitalize(color)}" has been created`
        },
        type: 'ok'
      },
      UPDATED: {
        title: 'Color Updated',
        message (color) {
          return `The color "${filters.capitalize(color)}" has been updated`
        },
        type: 'ok'
      },
      DELETED: {
        title: 'Color Deleted',
        message (color) {
          return `The color "${filters.capitalize(color)}" has been deleted`
        },
        type: 'ok'
      }
    },

    image: {
      DELETED: {
        title: 'Image Deleted',
        message (image) {
          return `The image "${image}" has been deleted`
        },
        type: 'ok'
      }
    },

    login: {
      SENT_CODE: {
        title: 'Código Enviado',
        type: 'ok'
      },

      LOGGED: {
        title: 'Logged',
        message: 'Login Correcto :)'
      }
    },

    all: {
      NOTHING_CHANGED: {
        title: 'Sin Cambios',
        message: 'Nada ha cambiado, edita algo y vuelve a intentar',
        type: 'error'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/messages.js